
















































import { Vue, Component, Prop, Emit } from "vue-property-decorator";
import { stringUtil } from "@/models/stringUtil.ts";
import { ElementMenuItem } from "@/models/elementMenuItem.ts";
import {
  PresetMenuItem,
  presets,
  PresetType,
  PresetStep,
} from "@/models/presets";
import { Vector2 } from "@babylonjs/core";
import { ElementType, SpecyficType } from "@/models/element";
import { base64Warehouse } from "@/models/base64warehouse";
import store from "@/store";
import SvgIcon from "@/components/SvgIcon.vue";

@Component({
  components: {
    SvgIcon,
  },
})
export default class AvatarComponent extends Vue {
  @Prop({ type: ElementMenuItem, required: true }) element: ElementMenuItem;

  private readonly avatar: string = this.element.avatar;
  private readonly label: string = this.element.text;
  private readonly useSvg: boolean = this.element.type === ElementType.FRONT;
  private readonly offset: number =
    this.$store.getters.configuration.tiny === "true" ? -1 : -1;
  private readonly previewSize: number =
    this.$store.getters.configuration.tiny === "true" ? 250 : 300;
  private readonly avatarSize: number =
    this.$store.getters.configuration.tiny === "true" ? 55 : 70;

  private isPopoverOpen = false;
  private openGroup = stringUtil.generateUUID();

  private get zoom(): boolean {
    const shape = this.$store.getters.product.shape;
    return (
      this.element.useZoom &&
      !(this.element.shape.x == shape.x && this.element.shape.y == shape.y)
    );
  }

  private readonly magUrl: string = this.createMagnificationUrl();

  private click(): void {
    if (this.$store.getters.scene.selectedElementMenuItem === this.element) {
      this.$store.commit("clearSceneState");
    } else {
      this.$store.commit("clearSceneState");
      this.$store.commit("selectElementMenuItem", this.element);
    }
  }

  private getClass(): string {
    let result: string = "clickable";

    if (this.$store.getters.scene.tasks) result += " disabled";
    if (this.$store.getters.scene.selectedElementMenuItem === this.element)
      result += " selected";

    return result;
  }

  private createMagnificationUrl(): string {
    const useSvg: boolean = this.element.type === ElementType.FRONT;
    const extenstion: string = useSvg ? "svg" : "png";
    const shape = this.$store.getters.product.shape;
    const url = `${shape.x}x${shape.y}_${
      this.element.avatar.split(".")[0]
    }_mag.${extenstion}`;
    return useSvg ? url : stringUtil.toMagnificationUrl(url);
  }
}
